export default __webpack_public_path__ + "static/media/ImmediateAssessment.c9bbc493.svg";